import React from 'react';
import PropTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';
import { MILE_RANGES } from '../../constants/filterConstants';

/**
 * Distance filter component that allows users to select search radius in miles.
 *
 * @param {Object} props
 * @param {number} props.currentRange - Currently selected radius (must be in MILE_RANGES)
 * @param {Function} props.onRangeChange - Callback when radius changes
 * @returns {JSX.Element}
 */
const DistanceFilter = ({ currentRange, onRangeChange }) => {
	const labels = useLabels();
	const distanceLabel = labels.get('DISTANCE') || 'Distance';

	const handleChange = (event) => {
		const newRange = parseInt(event.target.value, 10);
		onRangeChange(newRange);
	};

	return (
		<div>
			<select
				id="distance-filter-select"
				className="form-control"
				value={currentRange}
				onChange={handleChange}
				aria-label={`${distanceLabel} filter, currently ${currentRange} miles`}
			>
				{MILE_RANGES.map((range) => (
					<option key={range} value={range}>
						{range} miles
					</option>
				))}
			</select>
		</div>
	);
};

DistanceFilter.propTypes = {
	currentRange: PropTypes.oneOf([...MILE_RANGES]).isRequired,
	onRangeChange: PropTypes.func.isRequired
};

export default DistanceFilter;
